import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const StatutoryApprovalData = () => {
    
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Phase", value: "Phase", items: [] },
        { label: "SPOC", value: "SPOC", items: [] },
        { label: "Category", value: "Category", items: [] },
    ];

    return (
        <MasterData pageTitle="StatutoryApproval" sections={sections} />
    );
};

export default StatutoryApprovalData;